/**
 * Used to allow functions/classes to indicate that they should be registered as scoped with the container.
 */
export class ScopedRegistration {
    /**
     * Creates an instance of ScopedRegistration.
     * @param key The key to register as.
     */
    constructor(_key) {
        this._key = _key;
    }
    /**
     * Called by the container to register the resolver.
     * @param container The container the resolver is being registered with.
     * @param key The key the resolver should be registered as.
     * @param fn The function to create the resolver for.
     * @return The resolver that was registered.
     */
    registerResolver(container, key, fn) {
        const existingResolver = container.getResolver(this._key || key, false);
        return existingResolver === undefined
            ? container.registerScoped(this._key || key, fn)
            : existingResolver;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2NvcGVkUmVnaXN0cmF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiU2NvcGVkUmVnaXN0cmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGtCQUFrQjtJQUMzQjs7O09BR0c7SUFDSCxZQUFvQyxJQUFhO1FBQWIsU0FBSSxHQUFKLElBQUksQ0FBUztJQUFHLENBQUM7SUFFckQ7Ozs7OztPQU1HO0lBQ0ksZ0JBQWdCLENBQUMsU0FBb0IsRUFBRSxHQUFXLEVBQUUsRUFBZTtRQUN0RSxNQUFNLGdCQUFnQixHQUFHLFNBQVMsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLElBQUksSUFBSSxHQUFHLEVBQUUsS0FBSyxDQUFDLENBQUM7UUFFeEUsT0FBTyxnQkFBZ0IsS0FBSyxTQUFTO1lBQ2pDLENBQUMsQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxJQUFJLElBQUksR0FBRyxFQUFFLEVBQUUsQ0FBQztZQUNoRCxDQUFDLENBQUMsZ0JBQWdCLENBQUM7SUFDM0IsQ0FBQztDQUNKIn0=